<template>
  <div>
    <v-dialog
      v-model="processDialog"
      persistent
      max-width="700px"
    >
      <v-card style="border-radius: 16px">
        <form @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            >
              <span class="headline">Process Export Order</span>
            </v-flex>
            <v-flex xs1>
              <v-btn
                flat
                icon
                class="close"
                @click="$emit('close')"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <div class="row mx-0 mb-4">
              <div
                class="col-xs-4"
                style="font-size: 14px"
              >
                <b>Order No.:</b> {{ form.order_number }}
              </div>

              <div
                class="col-xs-4"
                style="font-size: 14px"
              >
                <b>Customer:</b> {{ form.customer.full_name }}
              </div>

              <div
                class="col-xs-4"
                style="font-size: 14px"
              >
                <b>Country:</b> {{ form.to_country.country_name }}
              </div>
            </div>

            <div class="row mx-0">
              <div class="col-md-4">
                <v-text-field
                  label="Weight"
                  v-model="form.weight"
                />
              </div>
              <div class="col-md-2">
                <v-select
                  :items="weightUnitList"
                  v-model="form.weight_unit"
                  :error-messages="errors.collect('Weight Unit')"
                  data-vv-name="Weight Unit"
                  v-validate="'required'"
                  autocomplete
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="Shipping"
                  v-model="form.shipping"
                  @input="calcPrice()"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="International Tax"
                  v-model="form.national_tax"
                  @input="calcPrice()"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="Delivery Price"
                  v-model="form.delivery_price"
                  @input="calcPrice()"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="Discount"
                  v-model="form.discount"
                  @input="calcPrice()"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="Total"
                  v-model="form.price"
                  :error-messages="errors.collect('Total')"
                  data-vv-name="Total"
                  v-validate="'required'"
                  readonly
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="From Date"
                  v-model="form.from_date"
                  type="date"
                  :error-messages="errors.collect('From Date')"
                  data-vv-name="From Date"
                  v-validate="'required'"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="To Date"
                  v-model="form.to_date"
                  type="date"
                  :error-messages="errors.collect('To Date')"
                  data-vv-name="To Date"
                  v-validate="'required'"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="Description"
                  v-model="form.description"
                  :error-messages="errors.collect('Description')"
                  data-vv-name="Description"
                />
              </div>

              <div class="col-md-6">
                <v-text-field
                  label="Process Note"
                  v-model="form.process_note"
                  :error-messages="errors.collect('Process Note')"
                  data-vv-name="Process Note"
                />
              </div>
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="$emit('close')"
              outline
              color="normal"
              class="mr-4"
            >
              Cancel
            </v-btn>

            <v-btn
              type="submit"
              style="height:auto; margin-right: 4%"
              outline
              color="success"
            >
              Save
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: {
    processDialog: { type: Boolean, default: false },
    form: { type: Object, default: () => { } }
  },

  data() {
    return {
      weightUnitList: [
        { text: 'KG', value: 'kg' },
        { text: 'LB', value: 'lb' }
      ]
    }
  },

  methods: {
    calcPrice() {
      let shipping = Number(this.form.shipping) || 0
      let tax = Number(this.form.national_tax) || 0
      let delivery = Number(this.form.delivery_price) || 0
      let discount = Number(this.form.discount) || 0
      this.form.price = (shipping + tax + delivery) - discount
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          let token = localStorage.getItem('access_token')

          Axios
            .put(`api/export-order/${this.form.export_order_id}/process`, this.form, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
              this.$emit('update-table')
              this.$emit('close')
            })
            .catch((error) => {
              swal('', error.response.data.message, 'error')
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/processExportOrder.vue